// ============================================================================
// 📋 CONSTANTES - CATEGORIAS PROFISSIONAIS PARA FINANCEIRO
// ============================================================================

// Categorias de Receita
export const CATEGORIAS_RECEITA = [
  "Venda de Imóvel",
  "Aluguel",
  "Comissão de Venda",
  "Comissão de Aluguel",
  "Taxa de Administração",
  "Sinal / Entrada",
  "Intermediação",
  "Reserva de Imóvel",
  "Outros",
];

// Categorias de Despesa
export const CATEGORIAS_DESPESA = [
  "Anúncios / Tráfego Pago",
  "Marketing",
  "Combustível",
  "Manutenção",
  "Fotografia",
  "Documentação",
  "Taxas",
  "Sistema / Software",
  "Outros",
];

// Categorias agrupadas por tipo (útil para selects)
export const CATEGORIAS = {
  receita: CATEGORIAS_RECEITA,
  despesa: CATEGORIAS_DESPESA
};

// Cores para cada categoria (para gráficos)
export const CORES_CATEGORIAS = {
  // Receitas
  "Venda de Imóvel": "#8b5cf6", // roxo
  "Aluguel": "#3b82f6", // azul
  "Comissão de Venda": "#10b981", // verde
  "Comissão de Aluguel": "#14b8a6", // teal
  "Taxa de Administração": "#f59e0b", // laranja
  "Sinal / Entrada": "#ec4899", // rosa
  "Intermediação": "#6366f1", // indigo
  "Reserva de Imóvel": "#a855f7", // roxo claro
  
  // Despesas
  "Anúncios / Tráfego Pago": "#ef4444", // vermelho
  "Marketing": "#f97316", // laranja escuro
  "Combustível": "#22c55e", // verde limão
  "Manutenção": "#eab308", // amarelo
  "Fotografia": "#a855f7", // roxo
  "Documentação": "#06b6d4", // ciano
  "Taxas": "#6b7280", // cinza escuro
  "Sistema / Software": "#3b82f6", // azul
  
  // Outros (fallback)
  "Outros": "#6b7280" // cinza
};

// Mensagens padrão para WhatsApp
export const WHATSAPP_MENSAGENS = {
  venda: "Olá! Gostaria de mais informações sobre esta venda.",
  aluguel: "Olá! Gostaria de mais informações sobre este aluguel.",
  receita: "Olá! Segue informação sobre receita.",
  despesa: "Olá! Segue informação sobre despesa."
};

// Exportação padrão com tudo
export default {
  receita: CATEGORIAS_RECEITA,
  despesa: CATEGORIAS_DESPESA,
  todas: [...CATEGORIAS_RECEITA, ...CATEGORIAS_DESPESA],
  cores: CORES_CATEGORIAS,
  whatsapp: WHATSAPP_MENSAGENS
};